"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDates = void 0;
const traverse_1 = __importDefault(require("traverse"));
const parseDates = (data) => {
    const regex = /(\d{4})-(\d{2})-(\d{2})T((\d{2}):(\d{2}):(\d{2}))\.(\d{3})Z/;
    (0, traverse_1.default)(data).forEach(function (item) {
        if (typeof item === "string") {
            if (regex.test(item)) {
                this.update(new Date(item));
            }
        }
    });
};
exports.parseDates = parseDates;
//# sourceMappingURL=parse-dates.js.map